import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
  background: theme.palette.background.paper,
  padding: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

export const AmountsBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
});

export const AmountTitle = styled(Typography)({
  fontWeight: "bold",
});

export const AmountBlock = styled(Grid)({
  overflow: "hidden",
});

export const Amounts = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "aceeptedAmount",
})<{ aceeptedAmount?: boolean }>(
  ({ theme }) => ({
    fontWeight: "bold",
    textTransform: "uppercase",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.error.main,
    textAlign: "end",
    textWrap: "nowrap",
  }),
  ({ aceeptedAmount, theme }) => ({
    ...(!!aceeptedAmount && {
      color: theme.palette.success.main,
    }),
  })
);
